export const DOWNLOAD_APP_LINK = 'https://apps.apple.com/app/teampaper-top-screenshot-tool/id1199502670';
